import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authFetch, API } from '../utils/api';


const SubscriptionContext = createContext({
  plan: 'free',
  isPro: false,
  usage: {},
  config: {},
  links: {},
  portal: '',
  loading: true,
  refresh: () => {},
});

export function SubscriptionProvider({ user, children }) {
  const [billing, setBilling] = useState({ plan: 'free', subscription: {}, links: {}, portal: '', config: {} });
  const [usage, setUsage] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    try {
      const [statusRes, usageRes] = await Promise.all([
        authFetch(`${API}/api/billing/status`),
        authFetch(`${API}/api/billing/usage`),
      ]);
      if (statusRes.ok) setBilling(await statusRes.json());
      if (usageRes.ok) setUsage(await usageRes.json());
    } catch {} finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isPro = billing.plan === 'pro';

  return (
    <SubscriptionContext.Provider value={{
      plan: billing.plan,
      isPro,
      subscription: billing.subscription,
      usage,
      config: billing.config,
      links: billing.links,
      portal: billing.portal,
      loading,
      refresh,
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}
